export const theme = {
  background: "#f9f9f9",
  black: "#000000",
  grassyGreen: "#309a02",
  // grassyGreen: "#007a45",
  grassyGreenTwo: "#30b202",
  green: "#139b37",
  treeGreen: "#157331",
  pastelRed: "#e65050",
  duskBlue: "#2b56a2",
  squash: "#f3b515",
  greyishBrown: "#3c3c3c",
  brownGrey: "#797979",
  lightPeach: "#b6b6b6",
  veryLightPink: "#e6e6e6",
  veryLightPinkTwo: "#ebebeb",
  white: "#f5f5f5",
  whiteTwo: "#ffffff",
  blueyGrey60: "rgba(144, 164, 183, 0.6)",
  blueyGrey30: "rgba(144, 164, 183, 0.3)",
  blueyGrey22: "rgba(144, 164, 183, 0.22)",
  grassyGreen50: "rgba(48, 154, 2, 0.51)",
  pastelRed50: "rgba(230, 80, 80, 0.5)",
  squash50: "rgba(243, 181, 21, 0.5)",
  fontWeight: {
    regular: 400,
    bold: 700,
    black: 900
  }
} 